import { render } from "./ServerStatsComponent.vue?vue&type=template&id=4b978b26"
import script from "./ServerStatsComponent.vue?vue&type=script&lang=js"
export * from "./ServerStatsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Agile-bot-web-dashboard/Agile-bot-web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__